import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useLinks from "../../hooks/useLinks";
import "./Footer.css";

const Footer = () => {
    const { book_your_slot_link } = useLinks();
    const location = useLocation();
    const navigate = useNavigate();

    const handleScrollToSection = (e, id) => {
        e.preventDefault();

        // If we are already on the home page, just scroll smoothly
        if (location.pathname === '/home' || location.pathname === '/') {
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
                window.history.pushState(null, '', `/home#${id}`);
            }
        } else {
            // Otherwise rapidly navigate to the Home page and append the #hash 
            // The logic added to HomePage.js will catch it, wait 100ms, and auto-scroll
            navigate(`/home#${id}`);
        }
    };

    return (
        <footer className="footer">
            <style>
                {`
                `}
            </style>
            <div className="footer-primary">
                <div className="container">
                    <div className="footer-content">
                        {/* Left Column - Contact Info */}
                        <div className="footer-column">
                            <h6 className="footer-title">Contact Us</h6>
                            <div className="flex flex-col gap-3">
                                <p className="footer-text mb-0">If you have any questions or need help, feel free to contact us</p>
                                <div className="contact-item">
                                    <a href="tel:7707018426">
                                        <i className="contact-icon fas fa-phone-alt"></i> <span>7707018426</span>
                                    </a>
                                </div>
                                <div className="contact-item">
                                    <a href="mailto:nvcti@iitism.ac.in">
                                        <i className="contact-icon fas fa-envelope"></i> <span>nvcti@iitism.ac.in</span>
                                    </a>
                                </div>
                                <div className="contact-item flex items-start">
                                    <i className="contact-icon fas fa-map-marker-alt mt-1"></i>
                                    <span className="footer-address ml-3">NVCTI, 2nd Floor, i2h Building, IIT (ISM) Dhanbad, Jharkhand, India 826004</span>
                                </div>
                            </div>
                        </div>

                        {/* Middle Columns - Navigation Links */}
                        <div className="footer-column">
                            <h6 className="footer-title">About Us</h6>
                            <ul className="footer-links">
                                <li><Link to="/about" onClick={() => window.scrollTo(0, 0)}>About Us</Link></li>
                                <li><a href="/home#think-innovation" onClick={(e) => handleScrollToSection(e, 'think-innovation')}>Mission & Vision</a></li>
                                <li><a href="/home#news-updates" onClick={(e) => handleScrollToSection(e, 'news-updates')}>News & Media</a></li>
                            </ul>
                        </div>



                        <div className="footer-column">
                            <h6 className="footer-title">Links</h6>
                            <ul className="footer-links">
                                {/* <li><a href="#">JH-SIC 2023</a></li> */}
                                <li><a href="https://www.iitism.ac.in/" target="_blank" rel="noopener noreferrer">IIT (ISM) Dhanbad</a></li>
                                {/* <li><a href="#">Institute Innovation</a></li> */}
                                {/* <li><a href="#">Apply for Projects</a></li> */}
                                {/* <li><a href="#">Services</a></li> */}
                                <li><Link to="/contact" onClick={() => window.scrollTo(0, 0)}>Contact us</Link></li>
                            </ul>
                        </div>

                        {/* Right Column - Working Hours */}
                        <div className="footer-column">
                            <h6 className="footer-title">Working Hours</h6>
                            <ul className="working-hours">
                                <li>
                                    <span className="day">Week Days</span>
                                    <span className="time">9:00 am - 9:00 pm</span>
                                </li>
                                <li>
                                    <span className="day">Saturday</span>
                                    <span className="time">9:00 am - 6:00 pm</span>
                                </li>
                                <li>
                                    <span className="day">Sunday</span>
                                    <span className="time">Weekly off</span>
                                </li>
                            </ul>
                            <div className="flex flex-col gap-4">
                                <button className="book-slot-button" onClick={() => window.open(book_your_slot_link, '_blank')}>
                                    Book Your Slot →
                                </button>

                                <a href="https://maps.app.goo.gl/3TuXzvQvy3TdkyCT7" target="_blank" rel="noopener noreferrer" className="btn btn-white btn-link mt-2 text-center text-white bg-[#f4572e] py-2 px-4 rounded-md font-medium hover:bg-[#e44d26] transition-colors duration-300">
                                    <i className="fas fa-map-marker-alt mr-2"></i> <span>Get Directions</span>
                                </a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom w-full bg-white px-4 py-4 shadow-md rounded-b-md">
                <div className="flex flex-col md:flex-row items-center justify-between gap-4">

                    {/* Empty Div to perfectly balance the right element and center the text */}
                    <div className="flex-1 hidden md:block"></div>

                    {/* Copyright - Center */}
                    <div className="text-center text-sm text-gray-500">
                        © {new Date().getFullYear()} NVCTI, All Rights Reserved. developed by{" "}
                        <a href="https://www.iitism.ac.in/" target="_blank" rel="noopener noreferrer" className="text-[#f4572e] font-medium hover:underline">IIT (ISM) Dhanbad</a>
                    </div>

                    {/* Red Circle - Right */}
                    <div className="flex-1 flex justify-center md:justify-end">
                        <div className="w-14 h-14 bg-[#f4572e] border-[3px] border-[#e5e7eb] rounded-full"></div>
                    </div>

                </div>
            </div>



        </footer >
    );
};

export default Footer;